<template>
  <div>
    <div class="header-row">
      <div>
        <h2>短信发送日志</h2>
        <p>查询配送员短信发送记录和发送结果。</p>
      </div>
      <el-button type="primary" plain @click="loadData">刷新</el-button>
    </div>

    <div class="stats-row">
      <div class="brand-card stat-card stat-card--success">
        <span>成功发送短信数量</span>
        <strong>{{ successCount }}</strong>
      </div>
      <div class="brand-card stat-card stat-card--failed">
        <span>发送失败短信数量</span>
        <strong>{{ failedCount }}</strong>
      </div>
    </div>

    <div class="brand-card filter-card">
      <div class="toolbar-row">
        <el-input v-model="filters.keyword" placeholder="手机号 / 订单号 / 配送员 / 错误原因" clearable />
        <el-input v-model="filters.scene_code" placeholder="场景编码" clearable />
        <el-select v-model="filters.result" placeholder="结果" clearable>
          <el-option label="成功" value="success" />
          <el-option label="失败" value="failed" />
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        />
        <el-button type="primary" plain @click="handleQuery">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="created_at" label="时间" min-width="180" />
        <el-table-column prop="scene_name" label="场景" min-width="140" />
        <el-table-column prop="scene_code" label="场景编码" min-width="160" />
        <el-table-column prop="phone" label="手机号" min-width="130" />
        <el-table-column prop="user_name" label="配送员" min-width="120" />
        <el-table-column prop="order_no" label="订单号" min-width="160" />
        <el-table-column prop="content_text" label="短信内容" min-width="260" show-overflow-tooltip />
        <el-table-column prop="result" label="结果" width="90">
          <template slot-scope="{ row }">
            <span :style="{ color: row.result === 'success' ? '#19be6b' : '#f56c6c' }">{{ row.result === "success" ? "成功" : "失败" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="error_message" label="错误原因" min-width="180" show-overflow-tooltip />
      </el-table>
      <div class="pager-row">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :page-size="pager.page_size"
          :current-page="pager.page"
          :page-sizes="[10, 20, 50]"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSmsSendLogs } from "../api/orders";

export default {
  data() {
    return {
      filters: { keyword: "", scene_code: "", result: "" },
      dateRange: [],
      items: [],
      total: 0,
      successCount: 0,
      failedCount: 0,
      pager: { page: 1, page_size: 10 },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const [created_start, created_end] = this.dateRange || [];
      const { data } = await fetchSmsSendLogs({
        keyword: this.filters.keyword || undefined,
        scene_code: this.filters.scene_code || undefined,
        result: this.filters.result || undefined,
        created_start: created_start || undefined,
        created_end: created_end || undefined,
        page: this.pager.page,
        page_size: this.pager.page_size,
      });
      this.items = data.items || [];
      this.total = data.total || 0;
      this.successCount = data.success_count || 0;
      this.failedCount = data.failed_count || 0;
    },
    handleQuery() {
      this.pager.page = 1;
      this.loadData();
    },
    onPageChange(page) {
      this.pager.page = page;
      this.loadData();
    },
    onSizeChange(size) {
      this.pager.page = 1;
      this.pager.page_size = size;
      this.loadData();
    },
  },
};
</script>

<style scoped>
.stats-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 260px));
  gap: 16px;
  margin-bottom: 16px;
}

.stat-card {
  padding: 18px 20px;
  border-left: 4px solid transparent;
}

.stat-card span {
  display: block;
  color: #60718f;
  font-size: 13px;
  line-height: 1.4;
}

.stat-card strong {
  display: block;
  margin-top: 8px;
  color: #1f2d3d;
  font-size: 28px;
  line-height: 1;
}

.stat-card--success {
  border-left-color: #16a34a;
}

.stat-card--failed {
  border-left-color: #dc2626;
}

@media (max-width: 720px) {
  .stats-row {
    grid-template-columns: 1fr;
  }
}
</style>
